import { OrganizationType } from "./Enums";
import { Status } from "./index";

export class Organization {
  ID: string;
  CREATED: string;
  NAME: string;
  ADDRESS: string;
  ADDRESS_EXT: string;
  CITY: string;
  STATE: string;
  STATUS: Status;
  ZIP: string;
  EMPLOYEE_LIMIT: number;
  ALLOW_LIMITED: boolean;
  DOMAIN: string;
  PHONE_NUMBER: string;
  ORGANIZATION_TYPE: OrganizationType;

  static parse(json: any): Organization {
    if (json) {
      const o = new Organization();

      o.ID = json.ID;
      o.CREATED = json.CREATED;
      o.NAME = json.NAME;
      o.ADDRESS = json.ADDRESS;
      o.ADDRESS_EXT = json.ADDRESS_EXT;
      o.CITY = json.CITY;
      o.STATE = json.STATE;
      o.STATUS = Status[<string>json.STATUS];
      o.ZIP = json.ZIP;
      o.EMPLOYEE_LIMIT = Number(json.EMPLOYEE_LIMIT);
      o.ALLOW_LIMITED = json.ALLOW_LIMITED;
      o.DOMAIN = json.DOMAIN;
      o.PHONE_NUMBER = json.PHONE_NUMBER;
      o.ORGANIZATION_TYPE = OrganizationType[<string>json.ORGANIZATION_TYPE];

      return o;
    } else return null;
  }

  static parseArray(json: Array<any>): Array<Organization> {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Organization.parse(j));

    return arr;
  }

}
